import { useMarkAsReadMutation } from '@/store/query/notification';
import { Button, Flex, Icon } from '@chakra-ui/react';
import { LinkExternal02 } from '@kula-ai/icons/dual-tone/LinkExternal02';

export const InterviewActionButtons = ({
  interviewUrl,
  meetingLink,
  notification,
}) => {
  const [markAsRead] = useMarkAsReadMutation();

  const handleJoinInterview = () => {
    markAsRead({ id: notification?.id });
    if (meetingLink) {
      window.open(meetingLink, '_blank');
    }
  };

  const handleViewCandidate = () => {
    markAsRead({ id: notification?.id });
    if (interviewUrl) {
      window.open(interviewUrl, '_blank');
    }
  };

  return (
    <Flex gap="6px">
      {meetingLink && (
        <Button onClick={handleJoinInterview}>Join interview</Button>
      )}
      {interviewUrl && (
        <Button
          variant={!meetingLink && interviewUrl ? 'primary' : 'quaternary'}
          rightIcon={<Icon as={LinkExternal02} />}
          onClick={handleViewCandidate}
        >
          View candidate
        </Button>
      )}
    </Flex>
  );
};
